import { Form, Row } from 'antd'
import React from 'react'
import type { SettingSection } from '../form.props'
import { CustomCol, FormLabels } from 'src/components'

const WhiteLabelFormSection: React.FC<{ sections: SettingSection[]}> = ({ sections }) => {
  const [form] = Form.useForm()

  const cols = {
    xs1: (item: SettingSection) => item.rowXs1 ? item.rowXs1 : 24,
    xs2: (item: SettingSection) => item.rowXs2 ? item.rowXs2 : 24,
    lg1: (item: SettingSection) => item.rowLg1 ? item.rowLg1 : 12,
    lg2: (item: SettingSection) => item.rowLg2 ? item.rowLg2 : 12,
  }

  return <Form form={form}>
    {sections.map((item, idx) => {
      if (!item.isVisible) return
      return <Row key={idx} className={item.rowClassName}>
        <CustomCol
          xs={cols.xs1(item)} lg={cols.lg1(item)}
          className={item.firstColClassName}
        >
          <FormLabels {...item.labels} />
        </CustomCol>
        <CustomCol xs={cols.xs2(item)} lg={cols.lg2(item)}>
          {item.form.children ? <>
            <item.form.component {...item.form.props}>
              {item.form.children}
            </item.form.component>
          </> : <item.form.component {...item.form.props} />}
        </CustomCol>
      </Row>
    })}
  </Form>
}

export default WhiteLabelFormSection
